import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'app-hello',
  templateUrl: './hello.component.html',
  styleUrls: [
    './hello.component.scss',
    './hello.background.scss',
    './hello.breakpoints.scss'
  ]
})
export class HelloComponent implements OnInit {

  constructor() { }

  ngOnInit() {

  }

}



// WEBPACK FOOTER //
// ./src/app/hello/hello.component.ts